<template>
  <div class="row">
    <div class="col-12 gutter-xs">
      <q-field
        :icon="icone"
        :disabled="desabilitar"
        :error="mensagemErro.length > 0"
        :error-label="mensagemErro"
        :count="dTamanho"
      >
        <q-input
          :name="name"
          :id="id"
          ref="inputText"
          v-model="termo"
          @blur="validarBlur"
          color="primary"
          :float-label="etiqueta"
          :placeholder="placeholder"
          @change="change"
          :maxlength="dTamanho"
          @keyup.13="chamarFuncaoNoEnter"
          :disable="desabilitar"
        >
          <q-autocomplete
            :name="name"
            :id="id"
            :min-characters="1"
            ref="autoComplete"
            @search="search"
            @selected="select"
            :max-results="20"
            :debounce="100"
            :separator="true"
            :disabled="desabilitar"
          />
        </q-input>
      </q-field>
    </div>
    <div class="col-12 text-right margin-neg">
      <q-btn
        class="clear-botao"
        @click="limpar"
        :disabled="desabilitar"
        v-show="itemSelecionado"
        flat
      >
        <q-icon
          name="close"
          size="20px"
          :disabled="desabilitar"
        />
      </q-btn>
    </div>
  </div>
</template>

<script>
import util from 'components/util/util'
import utilHttp from 'components/util/utilHttp'

export default {
  name: 'g-autocomplete',
  data () {
    return {
      dValue: this.value,
      termo: '', // TERMO DE PESQUISA
      mensagemErro: '',
      itemSelecionado: false,
      objetoSelecionado: {},
      dTamanho: this.tamanho,
      arrayRemover: []
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    sufixo: {
      type: [String, Number],
      default: ''
    },
    icone: {
      type: String,
      default: ''
    },
    tamanho: {
      type: Number,
      default: null
    },
    desabilitar: {
      type: [Boolean, String],
      default: false
    },
    acaoPosSelecao: {
      type: Function
    },
    placeholder: {
      type: String,
      default: ''
    },
    api: {
      type: String,
      default: ''
    },
    valor: {
      type: String,
      default: ''
    },
    descricaoPrimaria: {
      type: String,
      default: ''
    },
    descricaoSecundaria: {
      type: String,
      default: ''
    },
    descricaoTerciaria: {
      type: String,
      default: ''
    },
    validacao: {
      type: String,
      default: ''
    },
    etiqueta: {
      type: String,
      default: ''
    },
    permitirTextoLivre: {
      type: [Boolean, String],
      default: false
    },
    // HABILITAR A REMOÇÃO DE ACENTUAÇÃO NO TEXTO DIGITADO PELO USUÁRIO
    removerAcentuacao: {
      type: Boolean,
      default: false
    },
    // HABILITAR A CONVERÇÃO DOS CARACTERES DIGITADOS PARA MAIÚSCULO
    converterParaMaiusculo: {
      type: Boolean,
      default: false
    },
    change: {
      type: Function,
      default: () => { }
    },
    // FUNÇÃO A SER CHAMADA QUANDO O USUÁRIO PRESSIONAR O ENTER (13)
    chamarFuncaoNoEnter: {
      type: Function,
      default: () => { }
    },
    // Filtro adicional informado além do termo que é um filtro já encapsulado no compomente
    filtroAdicional: {
      type: Function,
      default: () => { return null }
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    limparAdicional: {
      type: Function,
      default: () => { }
    }
  },
  methods: {
    habilitarCampo () {
      this.disable = false
    },
    validarBlur () {
      if (!this.permitirTextoLivre) {
        if (!this.dValue) this.atualizarModelo(null)
        else {
          let valorInput = this.dValue && this.$refs['inputText'].value.trim()
          valorInput = util.removerAcentos(valorInput)
          valorInput = valorInput.toUpperCase()
          let valorDValue = this.dValue.value.trim()
          valorDValue = util.removerAcentos(valorDValue)
          valorDValue = valorDValue.toUpperCase()
          if (valorInput !== valorDValue) {
            this.dValue = null
          }
        }
      } else this.validar()
    },
    validar () {
      if (this.validacao.includes('required')) {
        if (this.permitirTextoLivre === false && !this.dValue) {
          this.mensagemErro = 'Campo obrigatório não informado'
          return false
        } else if (this.permitirTextoLivre === true && (this.termo === null || this.termo.length === 0)) {
          this.mensagemErro = 'Campo obrigatório não informado'
          return false
        } else this.mensagemErro = ''
      }
      return true
    },
    limpar () {
      this.dValue = null
      this.itemSelecionado = false
      this.limparAdicional()
    },
    limparObjetoSelecionado () {
      this.objetoSelecionado = {}
    },
    select (object) {
      this.itemSelecionado = true
      this.dValue = object
      this.objetoSelecionado = object.valorObjeto
      if (this.acaoPosSelecao) {
        this.acaoPosSelecao(object)
      }
    },
    search (termo, done) {
      // ADICIONA O SUFIXO COMO PARAMETROS EXTRAS
      if (this.sufixo) {
        termo = termo.concat('|').concat(this.sufixo)
      }

      // Recuperando o filtro adicional
      let filtro = this.filtroAdicional()

      if (termo) {
        if (filtro) {
          // Além do termo foi definido outros filtros
          utilHttp.httpGetTermoFiltro(this.api, termo, filtro, (resposta) => {
            this.searchCallback(resposta, done)
          })
        } else {
          // Busca apenas pelo termo
          utilHttp.httpGetTermo(this.api, termo, (resposta) => {
            this.searchCallback(resposta, done)
          })
        }
      }
    },
    // Tratamento da resposta
    searchCallback (resposta, done) {
      if (resposta.ok) {
        let tokens = resposta.body.map(o => {
          return {
            valor: util.FormatString(util.getItemRecursivo(this.valor, o)), // CHAVE DE CONTROLE INTERNO DO REGISTRO SELECIONADO
            valorObjeto: o, // CHAVE DE CONTROLE INTERNO DO REGISTRO SELECIONADO
            label: util.FormatString(util.getItemRecursivo(this.descricaoPrimaria, o)), // LABEL TITULO EM DESTAQUE
            sublabel: util.FormatString(util.getItemRecursivo(this.descricaoSecundaria, o)), // LABEL INFERIOR
            stamp: util.FormatString(util.getItemRecursivo(this.descricaoTerciaria, o)), // LABEL DA DIREITA
            value: util.FormatString(util.getItemRecursivo(this.descricaoPrimaria, o)) // VALOR QUE SERÁ CARREGADO PARA O CAMPO TEXTO AO SER SELECIONADO
          }
        })

        if (this.arrayRemover.length > 0) { /// remover elemento do body
          let listaRemover = this.arrayRemover.map(o => {
            return {
              valor: util.FormatString(util.getItemRecursivo(this.valor, o)), // CHAVE DE CONTROLE INTERNO DO REGISTRO SELECIONADO
              valorObjeto: o, // CHAVE DE CONTROLE INTERNO DO REGISTRO SELECIONADO
              label: util.FormatString(util.getItemRecursivo(this.descricaoPrimaria, o)), // LABEL TITULO EM DESTAQUE
              sublabel: util.FormatString(util.getItemRecursivo(this.descricaoSecundaria, o)), // LABEL INFERIOR
              stamp: util.FormatString(util.getItemRecursivo(this.descricaoTerciaria, o)), // LABEL DA DIREITA
              value: util.FormatString(util.getItemRecursivo(this.descricaoPrimaria, o)) // VALOR QUE SERÁ CARREGADO PARA O CAMPO TEXTO AO SER SELECIONADO
            }
          })

          for (let index = 0; index < tokens.length; index++) {
            for (let index2 = 0; index2 < listaRemover.length; index2++) {
              let codigo = tokens[index].valor
              if (parseInt(codigo) === parseInt(listaRemover[index2].valor)) {
                delete tokens[index]
                break
              }
            }
          }
        }

        done(tokens)
      }
    },

    atualizarModelo (value) {
      this.$refs['inputText'].$emit('input', value ? value.value : '')
      this.$emit('input', value ? value.valor : '')
      if (!value) {
        this.itemSelecionado = false
      }
      this.validar()
    },
    getTermo () {
      return this.termo
    },
    setTermo (termo) {
      this.termo = termo
    },
    carregar (valor, termo) {
      if (valor || termo) {
        this.$emit('input', valor)
        this.$refs['inputText'].$emit('input', termo)
        this.dValue = {
          valor: valor,
          value: termo
        }

        this.itemSelecionado = true
      }
    }
  },
  watch: {
    dValue (valor) {
      // RETIRAR ACENTOS
      if (this.removerAcentuacao) valor = util.removerAcentos(valor)
      // DEIXA MAIUSCULO
      if (this.converterParaMaiusculo && typeof valor === 'string') valor = valor.toUpperCase()
      this.atualizarModelo(valor)
    },
    termo (valor) {
      if (this.removerAcentuacao) valor = util.removerAcentos(valor)
      if (this.converterParaMaiusculo && typeof valor === 'string') valor = valor.toUpperCase()
      this.$refs['inputText'].$emit('input', valor)
      if (this.permitirTextoLivre === true && this.dValue && valor !== this.dValue.value) {
        this.itemSelecionado = false
        // Emite valor vazio, pois a descrição do campo não é a mesma do item selecionado
        this.$emit('input', '')
      }
    }
  }
}
</script>

<style>
.margin-neg {
  margin-top: -33px;
}

.clear-botao {
  bottom: 20px;
  min-height: 20px !important;
  min-width: 20px !important;
  width: 20px !important;
}
</style>
